import { EmptyState } from '../components/ui/EmptyState'
import { NOT_FOUND } from '../nav/manifest.ts'

/**
 * The catch-all, and the reason the lane's exit condition says "none 404s".
 *
 * A path the manifest does not claim lands here and says so. A path the manifest DOES claim
 * must never land here: that is the assertion in `routes.check.ts`, and it is the difference
 * between a navigation manifest and a list of links somebody hoped were wired up.
 *
 * Note what this screen does NOT do: it does not distinguish "no such screen" from "you are
 * not entitled to it". Entitlement is enforced server side against the same record the API
 * reads, and an unentitled resource answers 404 rather than 403, because a 403 confirms the
 * thing exists (NthAI.md, boundary rule 6). The console renders what the API said and does
 * not editorialise.
 */
export function NotFoundScreen() {
  return (
    <>
      <div className="page-head">
        <div>
          <div className="eb">Fleet Console</div>
          <h1>Not found</h1>
        </div>
      </div>

      <EmptyState
        icon={NOT_FOUND.icon}
        eyebrow="NO SUCH ADDRESS"
        title="No screen answers this address. Every screen in the console is reachable from the rail."
      />
    </>
  )
}
